import { BundleData } from 'client/bundles/types';

import { Direction } from '@yandex-lego/components/Popup/desktop';
import Breadcrumbs from 'client/components/breadcrumbs';
import Help from 'client/components/help';
import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';

import React, { Component } from 'react';

import StructureNode from './structure-node';

import './index.css';

import 'client/components/wiki-text/index.css';

const b = cn('key-businesses');
const bPageTitle = cn('page-title');

const DIRECTIONS: Direction[] = ['bottom-left', 'bottom-right', 'bottom-center'];

interface Props {
    title: string;
    help?: string;
    note: string;
    structure: BundleData['keyBusinesses']['structure'];
}

class KeyBusinesses extends Component<Props> {
    static contextType = LangContext;

    render() {
        const { title, help, structure, note } = this.props;
        const { dictionary } = this.context;

        return (
            <section className={b()}>
                <header className={b('header')}>
                    <Breadcrumbs link="/" text={dictionary.home} />

                    <h1 className={bPageTitle()}>{title}{help && (
                        <Help
                            mix={bPageTitle('help')}
                            content={help}
                            directions={DIRECTIONS}
                            />
                    )}
                    </h1>
                </header>
                <section className={b('structure')}>
                    {structure.map(
                        segment => <StructureNode key={segment.title} node={segment} />
                    )}
                </section>

                {
                    note ?
                        <div className={b('note')} dangerouslySetInnerHTML={{ __html: note }} /> :
                        null
                }
            </section>
        );
    }
}

export default KeyBusinesses;
